import React, { useContext, useState } from 'react'
import ContentCard from './ContentCard';
import {UserContext} from '../contexts/user-context';
import Helper from "../utils/helper";
import { withTranslation, Trans } from 'react-i18next';
import {Link} from "react-router-dom";

function UserSignUpComponent(props) {

  const userContext = useContext(UserContext)
  const [allValues, setAllValues] = useState({
    name: '',
    preposition: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    companyShortCode: ''
  });

  const changeHandler = e => {
    setAllValues({...allValues, [e.target.name]: e.target.value})
  }

  let errors = [];
  if(!Helper.isEmpty(userContext.errors)) {

    for (const [key, value] of Object.entries(userContext.errors)) {
      if (key != 'company_id') {
        errors.push(`${key}: ${value}`);
      }
    }
  }

  return (
    <ContentCard title={<Trans i18nKey="sign_up" />}>
          <form action="/users" method="POST" id="registerForm" noValidate>
              <input type="hidden" name="authenticity_token" id="csrf-token" value={document.querySelector('[name=csrf-token]').content} />
              <div className="mb-2">
                  <label htmlFor="name" className="form-label">
                      <Trans i18nKey="first_name" />*
                            </label>
                  <input
                      type="text"
                      name="name"
                      className="form-control"
                      id="name"
                      value={allValues.name}
                      onChange={changeHandler} />
              </div>
              <div className="mb-2">
                  <label htmlFor="Preposition" className="form-label">
                      <Trans i18nKey="prefix" />
                  </label>
                  <input
                      type="text"
                      name="preposition"
                      className="form-control"
                      id="preposition"
                      value={allValues.preposition}
                      onChange={changeHandler} />
              </div>
              <div className="mb-2">
                  <label htmlFor="lastName" className="form-label">
                      <Trans i18nKey="last_name" />*
                            </label>
                  <input
                      type="text"
                      name="lastName"
                      className="form-control"
                      id="lastName"
                      value={allValues.lastName}
                      onChange={changeHandler} />
              </div>
              <div className="mb-2">
                  <label htmlFor="email" className="form-label">
                      <Trans i18nKey="email_address" />*
                            </label>
                  <input
                      type="email"
                      name="email"
                      className="form-control"
                      id="email"
                      value={allValues.email}
                      onChange={changeHandler} />
              </div>
              <div className="mb-2">
                  <label htmlFor="password" className="form-label">
                      <Trans i18nKey="password" />*
                            </label>
                  <input
                      type="password"
                      name="password"
                      className="form-control"
                      id="password"
                      value={allValues.password}
                      onChange={changeHandler} />
              </div>
              <div className="mb-2">
                  <label htmlFor="confirmPassword" className="form-label">
                      <Trans i18nKey="verify_password" />*
                            </label>
                  <input
                      type="password"
                      name="confirmPassword"
                      className="form-control"
                      id="confirmPassword"
                      value={allValues.confirmPassword}
                      onChange={changeHandler} />
              </div>
              {userContext.companyCodeRequired &&
                  <div className="mb-2 mt-3 alert alert-warning" role="alert">
                      <h4><Trans i18nKey="company_not_found" /></h4>
                      <p><Trans i18nKey="company_no_match" /></p>
                      <input
                          type="text"
                          name="companyShortCode"
                          className="form-control"
                          id="companyCode"
                          value={allValues.companyShortCode}
                          onChange={changeHandler} />
                  </div>
              }
              {errors.length > 0 &&
                  <div className="alert alert-error" role="alert">
                      <h4><Trans i18nKey="error_generic" /></h4>
                      <ul>
                          {errors.map((value, key) => {
                            return <li key={value}><Trans>{value}</Trans></li>
                          })}
                      </ul>
                  </div>
              }
              <div className="mt-4 d-grid gap-2 col-9 mx-auto">
                  <button className="btn btn-primary btn-lg" type="button" onClick={() => userContext.signUp(allValues)}>
                      <Trans i18nKey="sign_up" />
                  </button>
                  <Link to="/" className="link text-center"><Trans i18nKey="back" /></Link>
              </div>
          </form>
    </ContentCard>
  );
}

export default withTranslation()(UserSignUpComponent);
